module.exports = __webpack_public_path__ + "static/RMMIRI-a2a23e19391aae4750623a2113e9f763.ttf";